import namespace from './namespace';

export default {
    [namespace.state.LOGGING_EVENTS]: null,
    [namespace.state.IDS_ARRAY_OF_ROWS_WAITING_FOR_DELETE]: [],
    [namespace.state.WAITING_FOR_RESPONSE]: false,
    [namespace.state.IS_SMTP_CONFIGURATION_ENABLED]: false
};


// WEBPACK FOOTER //
// ./src/store/modules/loggingEvents/state.js